export interface ApiResult<T> {
  code: string;
  data?: T;
  message: string;
  serverTime?: string;
  traceId: string;
}

export class ApiBusinessError extends Error {
  readonly code: string;
  readonly traceId?: string;

  constructor(code: string, message: string, traceId?: string) {
    super(message);
    this.name = 'ApiBusinessError';
    this.code = code;
    this.traceId = traceId;
  }
}

export const unwrapResult = <T>(result: ApiResult<T>): T => {
  if (result.code !== 'SUCCESS') {
    throw new ApiBusinessError(result.code, result.message, result.traceId);
  }

  return result.data as T;
};
